<template>
  <scroller :on-refresh="refresh" ref="myscroller">
    <main class="main">
      <div v-for="(item,index) in dataSource" :key="index">
        <RecommendBanner :dataSource="item" v-if="item.type === 1" />
        <RecommendCategories :dataSource="item" v-if="item.type === 2" />
        <RecommendVip :dataSource="item" v-if="item.type === 3" />
        <RecommendRecommend :dataSource="item" v-if="item.type === 4" />
        <RecommendCards :dataSource="item" v-if="item.type === 5" />
        <RecommendImages :dataSource="item" v-if="item.type === 6" />
        <RecommendCourses :dataSource="item" v-if="item.type === 7" />
        <RecommendCourses :dataSource="item" v-if="item.type === 8" />
        <RecommendWelfare :dataSource="item" v-if="item.type === 9" />
      </div>
    </main>
  </scroller>
</template>

<script>
import api from '@edu-fe/api'
import ShareMaker from '@/lib/shareMaker'

import RecommendBanner from './RecommendBanner'
import RecommendCategories from './RecommendCategories'
import RecommendVip from './RecommendVip'
import RecommendRecommend from './RecommendRecommend'
import RecommendCards from './RecommendCards'
import RecommendImages from './RecommendImages'
import RecommendCourses from './RecommendCourses'
import RecommendWelfare from './RecommendWelfare'
import login from '@/utils/login'

const requests = {
  get: api.create('/operation/homepage')
}
export default {
  name: 'recommend',
  data () {
    return {
      dataSource: [],
      client: ''
    }
  },

  methods: {
    async getData (client = 2) {
      const { code, data } = await requests.get({ client })
      if (code === 1) {
        console.log('data', data)
        this.dataSource = data
      } else {
        throw Error(`error: code=${code}`)
      }
      if (data) {
        this.$refs.myscroller.finishPullToRefresh()
      }
    },
    // 下拉刷新
    refresh: function () {
      this.getData(this.client)
    }
  },

  created () {
    login.login()
  },

  mounted () {
    this.getData(this.$route.query.client)
    this.client = this.$route.query.client
    return new ShareMaker(
      {
        title: '微课',
        introduction:
          '职业的发展取决于，工作8小时之外的学习，微课助力职场，成就精英！',
        imgUrl: this.$store.state.organizationMessage.organLogo,
        link: `https://course-m.auoktalk.com/recommend/?appId=${window.localStorage.getItem('wkAppId')}`
      },
      location.href,
      true
    )
  },
  components: {
    RecommendBanner,
    RecommendCategories,
    RecommendVip,
    RecommendCards,
    RecommendImages,
    RecommendCourses,
    RecommendWelfare,
    RecommendRecommend
  }
}
</script>

<style lang="scss">
@import "@style/recommend.module.scss";
</style>
